import { useRef } from "react";
import { useGSAP } from "@gsap/react";
import gsap from "gsap";

import { useReducedMotion } from "./useReducedMotion";

interface Props {
  to: number;
  comma?: boolean;
  duration?: number;
  className?: string;
}

/**
 * 数字滚动到位(GSAP 驱动)。onUpdate 只改 textContent 不触发 layout,已验证安全。
 * reduced-motion 时直接显终值,不做动画。全站共享;wecom-h5 旧路径 re-export 到此。
 */
export function CountUp({ to, comma, duration = 1.1, className }: Props) {
  const ref = useRef<HTMLSpanElement>(null);
  const reduced = useReducedMotion();
  const fmt = (n: number) => (comma ? Math.round(n).toLocaleString() : String(Math.round(n)));

  useGSAP(
    () => {
      const el = ref.current;
      if (!el) return;
      if (reduced) {
        el.textContent = fmt(to);
        return;
      }
      const o = { v: 0 };
      gsap.to(o, {
        v: to,
        duration,
        ease: "power1.out",
        onUpdate: () => {
          el.textContent = fmt(o.v);
        },
      });
    },
    { dependencies: [to, reduced], scope: ref }
  );

  return (
    <span ref={ref} className={className}>
      {reduced ? fmt(to) : "0"}
    </span>
  );
}
